var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 14.4688L18.25 11.9688C17.9375 11.6875 17.4688 11.6875 17.1875 11.9688C16.875 12.2812 16.875 12.75 17.1875 13.0312L18.4375 14.25H9.75C9.3125 14.25 9 14.5938 9 15C9 15.4375 9.3125 15.75 9.75 15.75H18.4375L17.2188 17C17.0625 17.125 17 17.3125 17 17.5C17 17.7188 17.0625 17.9062 17.2188 18.0312C17.5 18.3438 17.9688 18.3438 18.25 18.0312L20.75 15.5312C21.0625 15.25 21.0625 14.7812 20.75 14.4688ZM14.25 17C13.8125 17 13.5 17.3438 13.5 17.75V19C13.5 19.2812 13.25 19.5 13 19.5H5C4.71875 19.5 4.5 19.2812 4.5 19V7.03125C4.5 6.75 4.71875 6.53125 5 6.53125H10V9C10 9.5625 10.4375 10 11 10H13.4688V12.25C13.4688 12.6875 13.7812 13 14.1875 13C14.5625 13 15 12.6875 15 12.25V9.34375C15 8.8125 14.7812 8.3125 14.4062 7.9375L12.0625 5.59375C11.6875 5.21875 11.1875 5 10.6562 5H4.96875C3.875 5 2.96875 5.90625 3 7V19C3 20.125 3.875 21 5 21H13C14.0938 21 15 20.125 15 19V17.75C15 17.3438 14.6562 17 14.25 17Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.a3e910b0285c387a48bf8c33127f010d.svg";
export { ForwardRef as ReactComponent };